import { create } from "zustand";

interface NewListStore {
    open: boolean;
    setOpen: (open: boolean) => void;
}

const useNewListStore = create<NewListStore>((set) => ({
    open: false,
    setOpen: (open) => set({ open }),
}));

export default useNewListStore;
